<template>
  <el-form-item ref="rcTimeInterval" :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}"
                @mouseenter.stop.native="controlMouseOver(component, index)"
                @click.native="controlClick(component, index)" :prop="getProp" :rules="rules"
                class="rc-time-interval-run" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name"
                :label-width="labelParameter.width">
    <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{ labelParameter.labelName }}</div>
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain"
                :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
    <el-date-picker v-if="component.archive.dataType==='date'"
                    type="daterange"
                    range-separator="-"
                    v-model="tempValue"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    :title="tempValueTitle"
                    @change="updateValue"
                    :disabled="disabled || component.properties.readonly"
                    @focus="controlClick(component, index)"
                    :start-placeholder="this.getPlaceHolder('placeholder')"
                    :end-placeholder="this.getPlaceHolder('endTimeplaceholder')">
    </el-date-picker>
    <template v-if="component.archive.dataType==='time'">
      <el-time-picker
        class="time-input"
        :placeholder="this.getPlaceHolder('placeholder')"
        v-model="tempValue[0]"
        :title="tempValue[0]"
        value-format="HH:mm:ss"
        @change="updateValue($event,'start')"
        :disabled="disabled || component.properties.readonly"
        @focus="controlClick(component, index)"
        :picker-options="{ selectableRange: selectableRangeStart }">
      </el-time-picker>
      <span class="line">-</span>
      <el-time-picker
        class="time-input"
        value-format="HH:mm:ss"
        :placeholder="this.getPlaceHolder('endTimeplaceholder')"
        v-model="tempValue[1]"
        :title="tempValue[1]"
        @change="updateValue($event,'end')"
        :disabled="disabled || component.properties.readonly"
        @focus="controlClick(component, index)"
        :picker-options="{ selectableRange: selectableRangeEnd }">
      </el-time-picker>
    </template>
    <el-date-picker
      v-if="component.archive.dataType==='dateTime'"
      :picker-options="pickerOptions"
      type="datetimerange"
      range-separator="-"
      v-model="tempValue"
      value-format="yyyy-MM-dd HH:mm:ss"
      :title="tempValueTitle"
      @change="updateValue"
      :disabled="disabled || component.properties.readonly"
      @focus="controlClick(component, index)"
      :start-placeholder="this.getPlaceHolder('placeholder')"
      :end-placeholder="this.getPlaceHolder('endTimeplaceholder')">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { componentMixin, inputMixin, relFunMixin, calculationMixin, defaultValueMixin } from './mixins'
import moment from 'moment'
export default {
  name: 'rc-time-interval',
  mixins: [ componentMixin, inputMixin, relFunMixin, calculationMixin, defaultValueMixin ],
  props: ['component', 'value', 'disabled', 'labelParameter', 'index', 'tableCtrlKey'],
  data () {
    let tempValue = this.value || ['', '']
    return {
      tempValue,
      startTime: this.component.properties.selectData.startData ? moment(this.component.properties.selectData.startData).format('YYYY-MM-DD HH:mm:ss').split(' ')[1] : '00:00:00',
      endTime: this.component.properties.selectData.endData ? moment(this.component.properties.selectData.endData).format('YYYY-MM-DD HH:mm:ss').split(' ')[1] : '23:59:59',
      selectData: {}
    }
  },
  computed: {
    tempValueTitle () {
      let title = []
      this.tempValue && this.tempValue.forEach(m => {
        m && title.push(m)
      })
      return title
    },
    getPlaceHolder () {
      return type => this.component.properties[type] || (type === 'placeholder' ? '开始日期' : '结束日期')
    },
    // 时间区间开始要禁用的区域
    selectableRangeStart () {
      const {startData, endData} = this.selectData
      const start = startData ? moment(new Date(startData)).format('HH:mm:ss') : '00:00:00'
      const end = endData ? moment(new Date(endData)).format('HH:mm:ss') : '23:59:59'
      return `${start}-${end}`
    },
    // 时间区间开始要禁用的区域
    selectableRangeEnd () {
      const { endData } = this.selectData
      const end = endData ? moment(new Date(endData)).format('HH:mm:ss') : '23:59:59'
      // 时间区间  选择的开始时间-结束时间
      return `${this.tempValue[0]}-${end}`
    }
  },
  methods: {
    updateValue (e, type) {
      if (this.component.archive.enable && e) {
        let startTime
        let endTime
        if (this.component.archive.dataType === 'dateTime') {
          startTime = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
          endTime = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
        } else if (this.component.archive.dataType === 'time') {
          if (type === 'start') {
            startTime = e
            endTime = this.tempValue[1]
          }
          if (type === 'end') {
            startTime = this.tempValue[0]
            endTime = e
          }
        } else {
          startTime = moment(e[0]).format('YYYY-MM-DD')
          endTime = moment(e[1]).format('YYYY-MM-DD')
        }
        this.update({value: startTime, archiveColumnId: this.component.archive.columnId})
        this.update({value: endTime, archiveColumnId: this.component.properties.archived.endColumnId})
        this.$nextTick(() => this.$refs.rcTimeInterval.validate('blur'))
      }
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    }
  },
  watch: {
    'value' (val) {
      if (this.tempValue !== val) {
        this.tempValue = val || ['', '']
      }
    },
    tempValue (val) {
      if (val === null) {
        // 为了点击x，清空时间区间
        this.update({value: '', archiveColumnId: this.component.archive.columnId})
        this.update({value: '', archiveColumnId: this.component.properties.archived.endColumnId})
        this.$nextTick(() => this.$refs.rcTimeInterval.validate('blur'))
      }
    }
  },
  async created () {
    // 获取开始/结束时间计算结果
    this.selectData = await this.getStartAndEndDate()
  }
}
</script>
<style lang="scss">
.rc-time-interval-run .el-form-item__content {
  >div.el-date-editor {
    &.time-input {
      width: 49%;
      float: left;
    }

    width: 100%;

    .el-range-input {
      width: 46%;
      color: #000;
    }
  }

  .el-range-input {
    text-align: left;
  }

  .line {
    display: inline-block;
    width: 2%;
    height: 1px;
    float: left;
    text-align: center;
  }
}

.el-picker-panel {
  .el-picker-panel__footer {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-time-interval.vue